import { useInfiniteQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { ClientType } from '../ClientSearch.meta';

export interface ClientListClient {
  firstName: string;
  lastName: string;
  email: string | null;
  id: number;
  type: ClientType;
  onboardingEndpoint: string | null;
}

export interface ClientListDTO {
  clients: ClientListClient[];
  nextOffset: number | null;
}

interface ClientListQueryParams {
  search?: string;
  type?: ClientType;
}

interface FetchClientListParams extends ClientListQueryParams {
  offset?: number | null;
}

export const fetchClientList = async (
  params: FetchClientListParams = {},
): Promise<ClientListDTO> => {
  return authFetch(
    urlWithParams('/Adviser/Adviser/GetClientsScrollable', params, { skipNulls: true }),
  );
};

export const useClientListQuery = (params: ClientListQueryParams = {}) => {
  return useInfiniteQuery(
    queryKeys.clientList(params.search, params.type),

    ({ pageParam }) => fetchClientList({ offset: pageParam, ...params }),

    {
      getNextPageParam: ({ nextOffset }) => nextOffset,
    },
  );
};
